import { REPLACED } from '../../data/BomLineItemStatus';

import { getBomLineItemExtraData } from '../../utils/extracters';

export const replaceBomLineItemPart = (
  state,
  bom_line_item_id,
  part,
  part_supplier = null,
) => {
  const bli_index = state.bom_line_items.findIndex(
    (bp) => bp.id === bom_line_item_id,
  );
  state.bom_line_items[bli_index].user_action = 'buy';
  state.bom_line_items[bli_index].selected_part = _.cloneDeep(part);
  state.bom_line_items[bli_index].mpn = part.mpn;
  state.bom_line_items[bli_index].extra_parts = part.extra_parts;
  state.board_qtys.forEach((board_qty) => {
    state.bom_line_items[bli_index].status[board_qty] = REPLACED;

    if (board_qty == state.selected_board_qty && part_supplier)
      state.bom_line_items[bli_index].selected_part.selected_part_supplier[
        board_qty
      ] = _.cloneDeep(part_supplier);

    const {
      new_price_by_qty,
      new_qty_to_buy,
      error_message,
      markup,
      ps_selections_markups,
    } = getBomLineItemExtraData(
      state.bom_line_items[bli_index],
      board_qty,
      state.selected_board_qty,
    );

    state.bom_line_items[bli_index].error_message[board_qty] = error_message;
    state.bom_line_items[bli_index].qty_to_buy[board_qty] = new_qty_to_buy;
    state.bom_line_items[bli_index].calculated_minimun_order_qty[board_qty] =
      new_qty_to_buy;
    if (ps_selections_markups && ps_selections_markups.length > 0) {
      ps_selections_markups.forEach((ps_markup, index) => {
        state.bom_line_items[bli_index].selected_part.ps_selections[board_qty][
          index
        ]['markup'] = ps_markup;
      });
    }
    if (markup > 0)
      state.bom_line_items[bli_index].selected_part.selected_part_supplier[
        board_qty
      ]['markup'] = markup;
    if (new_price_by_qty)
      state.bom_line_items[bli_index].price_by_qty[board_qty] =
        new_price_by_qty;
  });
};
